import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconWifi24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="WiFi">
            <path
                d="M13 5C8.38349 5 4.32816 7.40562 2.02024 11.0364C1.72397 11.5025 1.10595 11.6402 0.63986 11.3439C0.173767 11.0477 0.0360989 10.4296 0.332369 9.96356C2.99181 5.77971 7.67095 3 13 3C18.3291 3 23.0082 5.77971 25.6676 9.96356C25.9639 10.4296 25.8262 11.0477 25.3601 11.3439C24.8941 11.6402 24.276 11.5025 23.9798 11.0364C21.6718 7.40562 17.6165 5 13 5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 18C10 16.3431 11.3432 15 13 15C14.6569 15 16 16.3431 16 18C16 19.6569 14.6569 21 13 21C11.3432 21 10 19.6569 10 18ZM13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M6.87514 14.4839C8.00961 12.4321 10.312 11 13 11C15.688 11 17.9904 12.4321 19.1249 14.4839C19.3921 14.9672 20.0006 15.1424 20.4839 14.8751C20.9672 14.6079 21.1424 13.9994 20.8751 13.5161C19.3813 10.8143 16.4007 9 13 9C9.59927 9 6.61874 10.8143 5.12487 13.5161C4.85763 13.9994 5.0328 14.6079 5.51612 14.8751C5.99945 15.1424 6.6079 14.9672 6.87514 14.4839Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconWifi48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            stroke={props.stroke || 'white'}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="WiFi">
            <circle
                cx="24"
                cy="37"
                r="3"
                strokeWidth="2"
                stroke={props.stroke || 'currentColor'}
            />
            <path
                d="M8.38657 24.5C12.0519 19.9277 17.684 17 24 17C30.316 17 35.9481 19.9277 39.6134 24.5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke={props.stroke || 'currentColor'}
            />
            <path
                d="M32.5 31.7296C30.7358 28.8903 27.5887 27 24 27C20.4113 27 17.2642 28.8903 15.5 31.7296"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke={props.stroke || 'currentColor'}
            />
            <path
                d="M1.3651 17.3102C6.86507 10.9929 14.9662 7 24 7C33.0338 7 41.1349 10.9929 46.6349 17.3102"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke={props.stroke || 'currentColor'}
            />
        </svg>
    );
}
